import { createSelector } from '@reduxjs/toolkit';

import { extractUndefinedValue } from 'shared/utils/extractUndefinedValue';

import { selectAdfoxOfferResponseData } from './selectAdfoxOfferResponseData';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectAdfoxYMEvents = createSelector(selectAdfoxOfferResponseData, (state: any) =>
  extractUndefinedValue(state?.ymEvents),
);
